export interface NedbetalingsplanList {
    avdrag: number;
    innbetaling: number;
    renterOgGebyr: number;
    restgjeld: number;
    termin: number;
}

const calculateAnnuitetsbeloep = (laanebeloep: number, terminrente: number, antallTerminer: number): number => {
    return (laanebeloep * terminrente) / (1 - (1 + terminrente) ** -antallTerminer);
};

const calculateInnbetaling = (
    laanebeloep: number,
    terminrente: number,
    antallTerminer: number,
    termingebyr: number,
    etabeleringsgebyr: number,
    foersteTermin: boolean,
): number => {
    return Math.round(
        calculateAnnuitetsbeloep(laanebeloep, terminrente, antallTerminer) +
            termingebyr +
            (foersteTermin ? etabeleringsgebyr : 0),
    );
};

const calculateRenteOgGebyr = (restGjeld: number, terminrente: number, termingebyr: number): number => {
    return Math.round(restGjeld * terminrente + termingebyr);
};

const calculateNedbetalingsplan = (
    laanebeloep: number,
    rente: number,
    antallTerminer: number,
    termingebyr: number,
    etabeleringsgebyr: number,
): NedbetalingsplanList[] => {
    const nedbetalingsplan: NedbetalingsplanList[] = [];
    const terminrente = rente / 100;
    let restGjeld = laanebeloep;

    for (let t = 1; t <= antallTerminer; t += 1) {
        const innbetaling = calculateInnbetaling(
            laanebeloep,
            terminrente,
            antallTerminer,
            termingebyr,
            etabeleringsgebyr,
            t === 1,
        );
        const renteOgGebyr = calculateRenteOgGebyr(restGjeld, terminrente, termingebyr);
        const avdrag = innbetaling - renteOgGebyr;
        restGjeld -= avdrag;
        nedbetalingsplan.push({
            termin: t,
            innbetaling,
            avdrag,
            renterOgGebyr: renteOgGebyr,
            restgjeld: restGjeld > 100 ? restGjeld : 0,
        });
    }
    return nedbetalingsplan;
};

export default calculateNedbetalingsplan;
